import { logOut, RefreshToken } from "../redux/slices/user";
import { store } from "../redux/store";

// Lock a nivel de módulo — compartido entre las 29+ instancias de helpHttp().
// Garantiza que solo un refresh ocurra a la vez aunque múltiples requests fallen
// con 401 simultáneamente.
let refreshPromise = null;

export const helpHttp = () => {
  const BASE_URL = "https://api.escuelaenlineafleischmann.com/";

  const customFetch = async (url, options = {}) => {
    const token = localStorage.getItem("token");

    options.body = JSON.stringify(options.body) || false;
    if (!options.body) delete options.body;

    if (token) {
      options.headers = {
        ...options.headers,
        Authorization: token,
      };
    }

    // AbortController para timeout. El timeoutId se limpia si la request
    // termina antes de los 60s, evitando el timer leak anterior.
    const controller = new AbortController();
    options.signal = controller.signal;
    const timeoutId = setTimeout(() => controller.abort(), 60000);

    let response;
    try {
      response = await fetch(`${BASE_URL}${url}`, options);
    } finally {
      clearTimeout(timeoutId);
    }

    if (response.status === 401) {
      const refreshToken = localStorage.getItem("refreshToken");

      if (!refreshToken) {
        store.dispatch(logOut());
        throw new Error("Sesión expirada. Por favor vuelve a ingresar.");
      }

      // Si ya hay un refresh en curso (otra request llegó primero al 401),
      // esperamos el mismo promise en lugar de lanzar otro request al backend.
      if (!refreshPromise) {
        refreshPromise = fetch(`${BASE_URL}usuarios/refreshtoken`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refreshToken }),
        })
          .then(async (res) => {
            if (!res.ok) {
              store.dispatch(logOut());
              throw new Error("Sesión expirada. Por favor vuelve a ingresar.");
            }
            return res.json();
          })
          .finally(() => {
            // Liberar el lock cuando el refresh termina (con éxito o error).
            refreshPromise = null;
          });
      }

      const refreshData = await refreshPromise;
      const newToken = refreshData.datos.token;
      const newRefreshToken = refreshData.datos.refreshToken;

      // Actualizar localStorage
      localStorage.setItem("token", newToken);
      if (newRefreshToken) {
        localStorage.setItem("refreshToken", newRefreshToken);
      }

      // Sincronizar Redux para que user.token no quede stale
      // (Test/index.js y Quiz.jsx leen el token desde el objeto user de Redux)
      store.dispatch(RefreshToken({ token: newToken }));

      // Reintentar la request original con el token nuevo
      const retryOptions = {
        ...options,
        signal: undefined, // el AbortController anterior ya expiró
        headers: {
          ...options.headers,
          Authorization: newToken,
        },
      };

      return customFetch(url, retryOptions);
    }

    if (!response.ok) {
      let message = "Ha ocurrido un error inesperado";
      try {
        const errorBody = await response.json();
        message = errorBody.message || errorBody.mensaje || message;
      } catch {
        // response.json() puede fallar si el body no es JSON válido
      }
      throw new Error(message);
    }

    return response.json();
  };

  const get = (url, options = {}) => {
    return customFetch(url, options);
  };

  const post = (url, options = {}) => {
    options.method = "POST";
    return customFetch(url, options);
  };

  const put = (url, options = {}) => {
    options.method = "PUT";
    return customFetch(url, options);
  };

  const del = (url, options = {}) => {
    options.method = "DELETE";
    return customFetch(url, options);
  };

  return {
    get,
    post,
    put,
    del,
  };
};
